module.exports = __webpack_public_path__ + "static/media/fotogalereya14.0b224b2c.jpg";